var CHINESE_RET = /[^\x00-\xff]/g;
export var chineseLength = function (str) {
    if (!str || (str && typeof str !== 'string'))
        return 0;
    var len = str.replace(CHINESE_RET, '##').length;
    return Math.ceil(len / 2);
};
export var validateLength = function (length, max) {
    if (length <= 0 || !max)
        return false;
    return length > max;
};
var getValueLength = function (_a) {
    var value = _a.value, max = _a.max;
    var length = chineseLength(value);
    var isBeyond = validateLength(length, max);
    return {
        isBeyond: isBeyond,
        length: length
    };
};
export default getValueLength;
